// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__V6M42"};